import React from 'react';
import DataGrid, { Column, Paging, Scrolling } from "devextreme-react/data-grid";
import moment from "moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ExcelImage from '../../../../../assets/images/excel.jpg';

const CollectionDetailsModal = ({ data }: { data: any[] }) => {
  const handleExportExcel = () => {
    if (!data || data.length === 0) return;
    const exportData = data.map(({ id, createdOn, ...rest }) => ({
      ...rest,
      Date: createdOn, // rename createdOn to Date
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "CollectionDetails");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(blob, "Collection_Details.xlsx");
  };
  return (
    <>
      <div className='d-flex justify-content-end align-items-center w-100'>
        <button
          onClick={handleExportExcel}
          className="btn btn-sm ms-3"
          title="Export to Excel"
        >
          <img
            src={ExcelImage}
            width={25}
            alt="Export"
          />
        </button>
      </div>
      <div style={{ maxWidth: '100%', overflowX: 'auto' }}>
        <DataGrid
          dataSource={data}
          keyExpr="id"
          showBorders={true}
          columnAutoWidth={true}
          width="100%"
        >
          <Scrolling
                        mode='standard'
                        useNative={true}
                        scrollByContent={true}
                        scrollByThumb={true}
                    />
          <Column dataField="invoiceNo" caption="Invoice No" width={200} alignment="center" />
          <Column dataField="paymentType" caption="Payment Type" width={150} alignment="center" />
          <Column dataField="amount" caption="Amount" dataType="number" format="#,##0.00" width={150} alignment="center" />
          <Column dataField="transactionId" caption="Transaction ID" width={200} alignment="center" />
          <Column
            dataField="createdOn"
            caption="Date"
            width={200}
            alignment="center"
            cellRender={(cellData) => moment(cellData.value).format("DD/MM/YYYY")}
          />
          <Paging enabled={false} />
        </DataGrid>
      </div>
    </>

  );
};

export default CollectionDetailsModal;
